<!-- @format -->

@if (studyFields?.length > 0 || searchTags?.length > 0) {
  <div class="row">
    <div class="col-md-12">
      <sis-description-list>
        <dl>
          <!-- This dl element is just to trick SonarQube, it won't actually end up in the final HTML at all -->
          @if (studyFields?.length > 0) {
            <ng-template #listItem>
              <dt class="label">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.STUDY_FIELDS" | translate }}</dt>
              <dd class="value">
                <ul class="no-bullets">
                  @for (studyFieldUrn of studyFields; track studyFieldUrn) {
                    <li>
                      {{ studyFieldUrn | codeLocalizedName | async }}
                    </li>
                  }
                </ul>
              </dd>
            </ng-template>
          }
          @if (searchTags?.length > 0) {
            <ng-template #listItem>
              <dt class="label">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.SEARCH_TAGS" | translate }}</dt>
              <dd class="value">
                <ul class="no-bullets">
                  @for (tag of searchTags; track tag) {
                    <li>
                      {{ tag }}
                    </li>
                  }
                </ul>
              </dd>
            </ng-template>
          }
        </dl>
      </sis-description-list>
    </div>
  </div>
} @else {
  <div>
    <span>{{ "SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN" | translate }}</span>
  </div>
}
